module.exports = __webpack_public_path__ + "img/avatar-agent.bd5eb6df.png";